import React from "react";
import { Link } from "react-router-dom";

export default function AutoDebitConsent({ agreed, setAgreed, monthlyPrice, trialDays }) {
  return (
    <label
      className={
        "flex items-start gap-3 p-4 border rounded-sm cursor-pointer transition mb-4 " +
        (agreed ? "border-pos-soft bg-pos-soft" : "border-subtle bg-app hover:border-focus")
      }
      data-testid="consent-label"
    >
      <input
        type="checkbox"
        checked={agreed}
        onChange={(e) => setAgreed(e.target.checked)}
        data-testid="consent-checkbox"
        className="mt-1 w-4 h-4 accent-emerald-500 shrink-0"
      />
      <div className="text-sm text-primary-fg/90 leading-relaxed">
        I agree to the <strong>auto-renewal and recurring charges</strong> of ₹{monthlyPrice} per month after
        the {trialDays}-day trial. I have read and accept the{" "}
        <Link to="/terms" className="text-pos underline underline-offset-2" target="_blank" rel="noreferrer">Terms &amp; Conditions</Link>
        ,{" "}
        <Link to="/refund" className="text-pos underline underline-offset-2" target="_blank" rel="noreferrer">Refund Policy</Link>
        {" "}and{" "}
        <Link to="/privacy" className="text-pos underline underline-offset-2" target="_blank" rel="noreferrer">Privacy Policy</Link>.
      </div>
    </label>
  );
}
